import { Content } from '../types/tour';

export const hydrateContent = (USER: string, content: Content) =>
  USER
    ? {
        ...content,
        blockquotes: content.blockquotes
          ? content?.blockquotes.map((b) => b.replace('USER_NAME', USER))
          : undefined,
      }
    : content;
